import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import useMediaQuery from "@mui/material/useMediaQuery";
import Divider from "@mui/material/Divider";
import { homeImageMainClose, homeImageMainOpen, pointer } from "../../style2";
// import IconButton from "@mui/material/IconButton";
// import MenuIcon from "@mui/icons-material/Menu";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
//import { useHistory, useLocation } from 'react-router-dom';


//const drawerWidth = 150;

// DrawerHeader keeps content aligned below AppBar
// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   padding: theme.spacing(0, 1),
//   ...theme.mixins.toolbar,
// }));

// Styled Drawer with conditional width
const Drawer = styled(MuiDrawer)(({ theme, open, drawerWidth = 150 }) => ({
  width: open ? drawerWidth : 72,
  flexShrink: 0,
  whiteSpace: "nowrap",
  "& .MuiDrawer-paper": {
    width: open ? drawerWidth : 72,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.standard,
    }),
    overflowX: "hidden",
  },
}));

export default function Newsidebar({ buttons }) {
  const theme = useTheme();
  const isBigScreen = useMediaQuery(theme.breakpoints.up("md"));
  const [open, setOpen] = useState(isBigScreen);

  //const handleDrawerToggle = () => setOpen(!open);

  useEffect(() => {
    setOpen(isBigScreen); // auto-sync open state with screen size
  }, [isBigScreen]);

  return (
    <Drawer variant="permanent" open={open} drawerWidth={isBigScreen ? 150 : 125}>
      {/* <DrawerHeader>
        {!open && (
          <IconButton onClick={handleDrawerToggle} className={classes.appbar}>
            <MenuIcon />
          </IconButton>
        )}
        {open && (
          <IconButton onClick={handleDrawerToggle} className={classes.appbar}>
            <ChevronLeftIcon />
          </IconButton>
        )}
      </DrawerHeader> */}

      {!open && <Divider />}

      <Box
        sx={{...pointer,
          textAlign: "center",
          pt: open ? 3 : 2,
          pl: open ? 0 : 1,
        }}
        
      >
        <Box component="img"
          src="logo-mycare-sm.png"
          alt="logo"
          sx={{...(open ? homeImageMainOpen : homeImageMainClose)}}
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        />
      </Box>

      <Box m={2} />
      <Box>{buttons}</Box>
    </Drawer>
  );
}
